import { useAntdTable, useDebounceFn } from 'ahooks'
import { Col, Form, Input, Row } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { UsersSearch } from '@/components'
import { Portfolio } from '@/schemas'

import { TeamTable } from './team-table.component'

interface PortfolioListProps {
  selfId: string
  editable: boolean
  renderExtras?: any
  portfolioType?: 1 | 2
}

export const TeamList: React.FC<PortfolioListProps> = ({ selfId, editable, renderExtras, portfolioType }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { tableProps, search, refresh } = useAntdTable<{ list: Portfolio[]; total: number }>(
    ({ current, pageSize, sorter, filters }, params) => {
      return {
        url: '/api/team/getTeams',
        params: {
          page: current,
          size: pageSize,
          name: params.name || null,
          startDate: params.date ? params.date[0].format('YYYY-MM-DD') : undefined,
          endDate: params.date ? params.date[1].format('YYYY-MM-DD') : undefined,
          email: params.email,
          ...(filters && filters.priority && { priorities: filters.priority }),
          sortBy: sorter?.columnKey,
          orderBy: sorter && sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : undefined,
        },
      }
    },
    {
      form,
      formatResult: (data) => ({
        list: data.list.map((d) => ({
          ...d,
          type: 3, // 提供给snapshots 新增团队 type
        })),
        total: data.total,
      }),
    }
  )

  const { run: runSearch } = useDebounceFn(search.submit, {
    wait: 500,
  })

  return (
    <div className='space-y-24px'>
      <Form form={form} onValuesChange={runSearch}>
        <Row gutter={[24, 0]}>
          <Col xs={6} lg={4}>
            <Form.Item name='name'>
              <Input allowClear placeholder={t('search department')} />
            </Form.Item>
          </Col>
          <Col xs={6} lg={4}>
            <Form.Item name='email'>
              <UsersSearch placeholder={t('owner')} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <TeamTable
        selfId={selfId}
        type={1}
        portfolioType={portfolioType}
        name={document.title}
        onSuccess={refresh}
        editable={editable}
        renderExtras={renderExtras}
        {...tableProps}
      />
    </div>
  )
}
